import {
  FETCH_SPHERE_FLAGS,
  FILTER_EVENTS_BY_FLAG,
  UPDATE_SPHERE_FLAGS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_SPHERE_FLAGS:
      return {
        ...state,
        ...action.payload
      }
    case UPDATE_SPHERE_FLAGS:
      return {
        ...state,
        ...action.payload
      }
    case FILTER_EVENTS_BY_FLAG:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
